import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Stars } from "@/components/Reviews";
import { toast } from "sonner";
import { PageHeader } from "./shared";

export default function ReviewsTab() {
    const [items, setItems] = useState([]);
    const [filter, setFilter] = useState("all");
    const refresh = () => api.get("/reviews").then((r) => setItems(r.data));
    useEffect(() => { refresh(); }, []);

    const setStatus = async (id, status) => {
        try { await api.patch(`/reviews/${id}/status`, { status }); toast.success(`Marked ${status}`); refresh(); }
        catch { toast.error("Update failed"); }
    };
    const remove = async (id) => {
        if (!window.confirm("Delete this review?")) return;
        try { await api.delete(`/reviews/${id}`); toast.success("Deleted"); refresh(); }
        catch { toast.error("Delete failed"); }
    };

    const STATUS = ["pending", "approved", "rejected"];
    const filtered = filter === "all" ? items : items.filter((r) => r.status === filter);

    return (
        <div data-testid="admin-reviews">
            <PageHeader eyebrow="Admin · Reviews" title="Moderate guest reviews." />
            <div className="flex gap-2 mb-6 flex-wrap">
                {["all", ...STATUS].map((s) => (
                    <button key={s} onClick={() => setFilter(s)} data-testid={`reviews-filter-${s}`} className={`px-4 py-2 text-xs uppercase tracking-widest2 border ${filter === s ? "bg-forest text-bone border-forest" : "border-espresso/20 text-espresso hover:bg-bone2"}`}>{s}</button>
                ))}
            </div>
            <div className="space-y-4">
                {filtered.length === 0 && <div className="text-muted2 text-sm">No reviews.</div>}
                {filtered.map((r) => (
                    <div key={r.id} className="border border-espresso/15 p-6" data-testid={`admin-review-${r.id}`}>
                        <div className="flex justify-between items-start mb-3 flex-wrap gap-3">
                            <div>
                                <div className="flex items-center gap-3 mb-1">
                                    <Stars value={r.rating} />
                                    <span className="text-xs uppercase tracking-widest2 text-espresso">{r.guest_name}</span>
                                </div>
                                <div className="text-xs text-muted2">{String(r.created_at).slice(0, 10)} · cabin {r.cabin_id.slice(0, 8)}</div>
                            </div>
                            <span className={`px-2 py-1 text-[10px] uppercase tracking-widest2 border ${r.status === "approved" ? "border-forest/40 text-forest" : r.status === "rejected" ? "border-terracotta/40 text-terracotta" : "border-espresso/30 text-espresso"}`}>{r.status}</span>
                        </div>
                        {r.title && <h4 className="font-serif text-2xl mb-2">{r.title}</h4>}
                        <p className="text-sm text-ink/80 leading-relaxed mb-4">{r.body}</p>
                        <div className="flex gap-3 flex-wrap">
                            {r.status !== "approved" && <button onClick={() => setStatus(r.id, "approved")} data-testid={`review-approve-${r.id}`} className="text-xs uppercase tracking-widest2 text-forest hover:text-terracotta">Approve</button>}
                            {r.status !== "rejected" && <button onClick={() => setStatus(r.id, "rejected")} data-testid={`review-reject-${r.id}`} className="text-xs uppercase tracking-widest2 text-terracotta hover:text-forest">Reject</button>}
                            {r.status !== "pending" && <button onClick={() => setStatus(r.id, "pending")} className="text-xs uppercase tracking-widest2 text-espresso hover:text-forest">Reset to pending</button>}
                            <button onClick={() => remove(r.id)} data-testid={`review-delete-${r.id}`} className="text-xs uppercase tracking-widest2 text-terracotta hover:text-forest">Delete</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
